import { InjectionToken } from '@angular/core';

/**
 * Identifies which authentication provider is active.
 * - 'Okta'  – Halliburton Okta OIDC (used in QA/Prod)
 * - 'Entra' – Microsoft Entra ID via MSAL (used in Dev/Local)
 * - 'Api'   – Custom JWT-based auth via the internal auth-api
 */
export type AuthProvider = 'Okta' | 'Entra' | 'Api';

export const AUTH_PROVIDER_TOKEN = new InjectionToken<AuthProvider>('AUTH_PROVIDER_TOKEN');
